import styled from 'styled-components'

export const StyledContainer = styled.div`
  margin: 0 auto;
  max-width: 90rem;
  display: flex;
`

export const StyledRow = styled.div`
  max-width: 56.875rem;
  width: 100%;
  padding: 0 1rem;

  @media screen and (min-width: 48rem) and (max-width: 94.5rem) {
    padding: 0 2.25rem;
  }

  @media screen and (min-width: 94.5rem) {
    padding: 0;
  }
`

export const WideColumn = styled.div`
  width: 100%;

  @media screen and (min-width: 48rem) {
    width: 66%;
    padding-right: 5rem;
  }
`

export const SidebarColumn = styled.div`
  width: 100%;

  @media screen and (min-width: 48rem) {
    width: 33%;
  }
`
